import { enumFolderStatus } from "../constants";

export function CheckIfPrivate(folderName, curGroup, groupStatus) {
  if (folderName.charAt(0) == "[") {
    var lastChar = folderName.charAt(folderName.length - 1);
    if (lastChar == "]") {
      // Is it is private but is also in the access group!
      if (curGroup && groupStatus != enumFolderStatus.notingroup) return false;

      return true;
    }
  }

  return false;
}
